const STORAGE_KEYS = {
  LOGIN: 'LOGIN', // old-Minerva interop, shared-origin localStorage key, do not rename
  USER_ID: 'USER_ID',
  TOKEN: 'SESSION_TOKEN',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  ACCESS_TOKEN_DEADLINE: 'ACCESS_TOKEN_DEADLINE',
} as const;

const MILLISECONDS_IN_SECOND = 1000;

type SessionTokens = {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresIn: number;
};

type Session = SessionTokens & {
  login: string;
  userId: number;
  token: string;
};

export const setTokens = ({
  accessToken,
  refreshToken,
  accessTokenExpiresIn,
}: SessionTokens): void => {
  const deadline = Date.now() + accessTokenExpiresIn * MILLISECONDS_IN_SECOND;
  window.localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  window.localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  window.localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN_DEADLINE, String(deadline));
};

export const setSession = ({ login, token, userId, ...tokens }: Session): void => {
  window.localStorage.setItem(STORAGE_KEYS.LOGIN, login);
  window.localStorage.setItem(STORAGE_KEYS.USER_ID, `${userId}`);
  window.localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  setTokens(tokens);
};

export const getLogin = (): string | null => window.localStorage.getItem(STORAGE_KEYS.LOGIN);

export const getUserId = (): number | null => {
  const userId = window.localStorage.getItem(STORAGE_KEYS.USER_ID);
  if (userId === null) return null;
  const parsedUserId = Number(userId);
  return Number.isNaN(parsedUserId) ? null : parsedUserId;
};

export const getToken = (): string | null => window.localStorage.getItem(STORAGE_KEYS.TOKEN);

export const getAccessToken = (): string | null =>
  window.localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);

export const getRefreshToken = (): string | null =>
  window.localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);

export const getAccessTokenDeadline = (): number | null => {
  const deadline = window.localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN_DEADLINE);
  return deadline ? Number(deadline) : null;
};

export const clearSession = (): void => {
  Object.values(STORAGE_KEYS).forEach(key => window.localStorage.removeItem(key));
};
